if (!customElements.get("discount-code-apply")) {
  customElements.define(
    "discount-code-apply",
    class DiscountCodeApply extends HTMLElement {
      constructor() {
        super();
        this.submitLoading = false
        this.sectionId = this.dataset.sectionId
        this.handleApplyCodeClick = this.handleApplyCode.bind(this)
        this.handleApplyCodeKeyup = this.handleApplyCodeByEnter.bind(this)
      }

      connectedCallback() {
        this.init()
      }

      disconnectedCallback() {
        this.unbindEvents()
        this.discountCodeEventsController?.abort()
      }

      init() {
        this.unbindEvents()
        this.discountCodeEventsController?.abort()
        this.applyButton = this.querySelector('.apply-code-btn')
        this.input = this.querySelector('input')
        this.errorIcon = this.querySelector('.error-icon')
        this.addCodeTip = this.querySelector('.add-code-tip')
        this.inputWrapper = this.querySelector('.discount-code-input-wrapper')

        this.applyButton?.addEventListener('click', this.handleApplyCodeClick)
        this.applyButton?.addEventListener('keyup', this.handleApplyCodeKeyup)
        this.initDiscountCodeEvent();
        this.addCodeTip?.addEventListener('click', this.handleToggleInput)
      }

      unbindEvents() {
        this.applyButton?.removeEventListener('click', this.handleApplyCodeClick)
        this.applyButton?.removeEventListener('keyup', this.handleApplyCodeKeyup)
        this.addCodeTip?.removeEventListener('click', this.handleToggleInput)
      }

      setButtonLoading(bool) {
        if (!this.applyButton) return
        if (bool) {
            this.applyButton.setAttribute('disabled', true)
            this.applyButton.classList.add('btn--loading')
            this.applyButton.querySelector('.btn-text')?.classList.add('hidden')
        } else {
            this.applyButton.removeAttribute('disabled')
            this.applyButton.querySelector('.btn-text')?.classList.remove('hidden')
            this.applyButton.classList.remove('btn--loading')
        }
      }

      async updateCartFooter() {
        try {
            const response = await fetch(`${FoxTheme.routes.root_url ?? ''}?section_id=${this.sectionId}`);
            const responseText = await response.text();

            const parser = new DOMParser();
            const parsedHTML = parser.parseFromString(responseText, 'text/html');

            const newCartFooterContent = parsedHTML.getElementById('CartDrawer')?.querySelector(`#CartDrawerFooter-${this.sectionId} .drawer__footer-body`);
            const curCartFooter = document.documentElement.querySelector(`#CartDrawerFooter-${this.sectionId} .drawer__footer-body`)
            if (newCartFooterContent && curCartFooter) {
                curCartFooter.innerHTML = newCartFooterContent.innerHTML
            }
            requestAnimationFrame(() => {
              this.initDiscountCodeEvent();
            })
        } catch(e) {
            console.error(e)
        }
      }

      async checkCodeValidated() {
        const res = await fetch(`/cart.js`)
        const cartData = await res.json()
        const discountCodes = cartData.discount_codes
        const inputCode = this.pendingDiscountCode || this.input?.value
        if (!discountCodes?.length || !discountCodes.find((item) => item.code === inputCode)?.applicable) {
            this.errorIcon?.classList.remove('hidden')
            setTimeout(() => {
                this.errorIcon?.classList.add('hidden')
            }, 3000);
        }
        if (this.input) this.input.value = ''
      }

      handleApplyCodeByEnter(e) {
        const keyCode = e.which || e.keyCode
        const isEnter = keyCode === 13 || e.key === 'Enter'
        if (isEnter && !e.shiftKey && !e.ctrlKey) {
          this.handleApplyCode()
        }
      }

      async handleApplyCode() {
        if (!this.input || this.submitLoading) return
        const discountCode = this.input.value
        if (!discountCode) return
        this.pendingDiscountCode = discountCode
        this.submitLoading = true
        this.setButtonLoading(true)
        try {
            await fetch('/discount/' + encodeURIComponent(discountCode));
            await this.checkCodeValidated()
            await this.updateCartFooter()
        } catch(e) {
            console.error(e)
            this.errorIcon?.classList.remove('hidden')
            setTimeout(() => {
                this.errorIcon?.classList.add('hidden')
            }, 3000);
        } finally{
            this.setButtonLoading(false)
            this.submitLoading = false
            this.pendingDiscountCode = ''
        }
      }

      initDiscountCodeEvent() {
        this.discountCodeEventsController?.abort()
        this.discountCodeEventsController = new AbortController()
        const discountCodes = document.documentElement.querySelectorAll(`#CartDrawerFooter-${this.sectionId} .drawer__footer-body .discounts .discount`)
        if (!discountCodes?.length) return
        discountCodes.forEach((codeDom) => {
          const closeIconDom = codeDom.querySelector('.close')
          if (!closeIconDom) return
          const loadingIconDom = codeDom.querySelector('.loading')
          closeIconDom.addEventListener('click', async () => {
          loadingIconDom?.classList.remove('hidden')
          closeIconDom.classList.add('hidden')
            try {
              await fetch('/checkout?discount='); 
              codeDom.classList.add('hidden')
              this.updateCartFooter();
            } catch(e) {
              console.error(e)
            } finally{
              loadingIconDom?.classList.add('hidden')
              closeIconDom.classList.remove('hidden')
            }
          }, { signal: this.discountCodeEventsController.signal })
        })
      }

      handleToggleInput = () => {
        if (this.inputWrapper) {
          if (this.inputWrapper.classList.contains('hidden')) {
            this.inputWrapper.classList.remove('hidden')
            this.addCodeTip?.querySelector('.plus-icon')?.classList.add('hidden')
            this.addCodeTip?.querySelector('.minus-icon')?.classList.remove('hidden')
          } else {
            this.inputWrapper.classList.add('hidden')
            this.addCodeTip?.querySelector('.minus-icon')?.classList.add('hidden')
            this.addCodeTip?.querySelector('.plus-icon')?.classList.remove('hidden')
          }
        }
      }

    })
}
